import React, { lazy } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { UI_LOGBOOK_DATE } from 'globalconfig/constants/static';
import RenderComponent from './RenderComponent';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Form = lazy(() => import(`globalcomponents/UI/Form/${layout}`));

const ViewForm = ({
  fetchTableData,
  hasApiStatus,
  callback,
  history,
  driverList,
  vehicleListDropDown,
  fetchChartData,
  Styled,
  fetchDriverBehaviorDetails,
}) => {
  const handleSubmit = (fields) => {
    const formattedFields = {
      ...fields,
      id: fields?.id?.value || '',
      vehicleId: fields?.vehicleId?.value || '',
      startDate: fields.startDate ? moment(fields.startDate).format(UI_LOGBOOK_DATE) : '',
      endDate: fields.endDate ? moment(fields.endDate).format(UI_LOGBOOK_DATE) : '',
    };

    const requestPayload = {
      apiId: 'fetchTableData',
      data: formattedFields,
      type: 'hardTurn',
    };

    fetchTableData(requestPayload);
    fetchChartData(requestPayload);
  };

  const handleCancel = () => {
    fetchDriverBehaviorDetails({
      apiId: 'fetchDriverDetails',
    });
    fetchTableData({
      apiId: 'fetchTableData',
      data: {
        endDate: '',
        startDate: '',
        id: '',
      },
      type: 'hardTurn',
    });
  };

  return (
    <Styled.Wrapper>
      <Form
        type="server"
        direction="row"
        initialValues={{
          vehicleId: '',
          endDate: '',
          startDate: '',
          id: '',
        }}
        className="CSAForms"
        RenderComponent={RenderComponent}
        handleOnSubmit={handleSubmit}
        handleOnCancel={handleCancel}
        customProps={{
          history,
          callback,
          hasApiStatus,
          driverList,
          vehicleListDropDown,
        }}
      />
    </Styled.Wrapper>
  );
};

ViewForm.propTypes = {
  apiStatus: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
};

export default ViewForm;
